import React from "react";

export const errorContent = (text) => {
  let html = [];

  if (typeof text === "object") {
    for (const key in text) {
      if (text[key]) {
        html.push(
          <>
            {text[key]}
            <br />
          </>
        );
      }
    }
  } else if (text) {
    html.push(text);
  }

  // Fallback text if no content is provided
  if (html.length === 0) {
    html.push("Something went wrong. Please try again.");
  }

  return (
    <div className="toast-innerbody">
      <div className="toast-icon-wrapper toast-icon-error">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8 8L16 16M16 8L8 16"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <p className="toast-innerbody-message">{html}</p>
    </div>
  );
};
